import theme from "assets/theme";
import React, { useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import CustomModal from "../CustomModal.component";
import CustomButton from "./CustomButton.component";
import LabelInput from "./LabelInput.component";

const classes = StyleSheet.create({
  label: {
    fontWeight: theme.font.weight.medium,
    color: theme.color.darkGrey,
    marginLeft: 10,
    marginBottom: 5,
  },
  colorPreview: {
    height: 50,
    width: 100,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: theme.color.lightGrey,
    marginHorizontal: 10,
    marginBottom: 10,
  },
  modalContent: {
    alignItems: "center",
    padding: 20,
    minWidth: 300,
  },
  colorGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    maxWidth: 280,
    marginBottom: 20,
  },
  colorSwatch: {
    width: 40,
    height: 40,
    margin: 5,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: "transparent",
  },
  selectedSwatch: {
    borderColor: theme.color.darkGrey,
    borderWidth: 3,
  },
  customColorSection: {
    width: "100%",
    marginTop: 20,
    alignItems: "center",
  },
  hexInputContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 10,
  },
  disabledOpacity: {
    opacity: 0.5,
  },
  modalTitle: {
    textAlign: "center",
    fontSize: 16,
    marginBottom: 15,
  },
  hexInput: {
    minWidth: 120,
    marginRight: 10,
  },
  previewSwatch: {
    width: 50,
    height: 40,
    margin: 0,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: theme.color.lightGrey,
  },
});

const COLOR_PALETTE = [
  "#1554A3",
  "#1982c4",
  "#6f8fff",
  "#44c8e5",
  "#0ead69",
  "#2ac734",
  "#8ad25e",
  "#ecad41",
  "#fc7f03",
  "#d9b511",
  "#d36149",
  "#a8070c",
  "#de0bbb",
  "#7700b3",
  "#754c00",
  "#333233",
  "#7d7f80",
  "#919090",
  "#bababa",
  "#f5f5f5",
];

export default function ColorPickerComponent(props) {
  const {
    label,
    selectedColor = theme.color.primary,
    setSelectedColor,
    disabled,
  } = props;

  const normalizedSelectedColor =
    selectedColor && selectedColor.startsWith("#") ? selectedColor : "#1554A3";

  const [modalVisible, setModalVisible] = useState(false);
  const [tempColor, setTempColor] = useState(normalizedSelectedColor);
  const [customHex, setCustomHex] = useState("");

  const isValidHex = (hex) => {
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);
  };

  const normalizeHex = (hex) => {
    let returnHex;
    if (!hex) {
      return "#1554A3";
    }
    returnHex = hex.trim();
    if (!returnHex.startsWith("#")) {
      returnHex = "#" + returnHex;
    }
    if (returnHex.length === 4) {
      returnHex =
        "#" +
        returnHex[1] +
        returnHex[1] +
        returnHex[2] +
        returnHex[2] +
        returnHex[3] +
        returnHex[3];
    }
    return returnHex.toUpperCase();
  };

  const handleSwatchPress = (color) => {
    setTempColor(color);
    setCustomHex(color);
  };

  const handleCustomHexChange = (text) => {
    setCustomHex(text);
    const normalizedHex = normalizeHex(text);
    if (isValidHex(normalizedHex)) {
      setTempColor(normalizedHex);
    }
  };

  const handleSaveColor = () => {
    if (isValidHex(tempColor)) {
      setSelectedColor(tempColor);
      setModalVisible(false);
    }
  };

  const handleCancel = () => {
    setTempColor(normalizedSelectedColor);
    setCustomHex(normalizedSelectedColor);
    setModalVisible(false);
  };

  const handleModalOpen = () => {
    setTempColor(normalizedSelectedColor);
    setCustomHex(normalizedSelectedColor);
    setModalVisible(true);
  };

  return (
    <View>
      <Text style={classes.label}>{label}</Text>
      <TouchableOpacity
        onPress={() => !disabled && handleModalOpen()}
        disabled={disabled}
      >
        <View
          style={[
            classes.colorPreview,
            { backgroundColor: normalizedSelectedColor },
            disabled && classes.disabledOpacity,
          ]}
        />
      </TouchableOpacity>
      <CustomButton
        title="Choose Color"
        variant="outline"
        disabled={disabled}
        onPress={() => !disabled && handleModalOpen()}
      />

      <CustomModal
        open={modalVisible}
        onClose={handleCancel}
        onSave={handleSaveColor}
        canSave={isValidHex(tempColor)}
        saveTitle="Select Color"
        title="Choose Organization Color"
      >
        <View style={classes.modalContent}>
          <Text style={[classes.label, classes.modalTitle]}>
            Select a Color
          </Text>

          <View style={classes.colorGrid}>
            {COLOR_PALETTE.map((color) => (
              <TouchableOpacity
                key={color}
                onPress={() => handleSwatchPress(color)}
                testID={color}
              >
                <View
                  style={[
                    classes.colorSwatch,
                    { backgroundColor: color },
                    tempColor === color && classes.selectedSwatch,
                  ]}
                />
              </TouchableOpacity>
            ))}
          </View>

          <View style={classes.customColorSection}>
            <Text style={classes.label}>Or enter a custom hex color:</Text>
            <View style={classes.hexInputContainer}>
              <LabelInput
                placeholder="#1554A3"
                value={customHex}
                onChangeText={handleCustomHexChange}
                style={classes.hexInput}
              />
              <View
                style={[
                  classes.previewSwatch,

                  {
                    backgroundColor: isValidHex(tempColor)
                      ? tempColor
                      : "#ffffff",
                  },
                ]}
              />
            </View>
          </View>
        </View>
      </CustomModal>
    </View>
  );
}
